
import React, { useEffect, useState, forwardRef } from "react";
import { debounce } from "../hooks/debounce";
import NumberFormat from "react-number-format";

/**
 * @description Debounced text field
 * @param {string} url optional - post updates to this url
 * @param {string} field optional - update this field
 * @param {number} delay optional - delay in ms before sending, default 1000
 * @param {number} fontSize optional - font size in px, default 16
 * @param {boolean} vnd optional - format as VND
 * @param {string} align optional - left, center, right 
 * @returns 
 */

type TextAlign = "left" | "right" | "center";


type TextType = {
  value: string | number;
  setValue: Function;
  url?: string;
  field?: string;
  delay?: number;
  fontSize?: string;
  vnd?: boolean;
  align?: TextAlign;
  style?: any;
  className?: string;
  http?: string;
  label?: string;
  fullWidth?: boolean;
  helperText?: string;
  type?: string;
  error?: boolean;
  startAdornment?: string | React.ReactNode;
  endAdornment?: string | React.ReactNode;
  autoComplete?: string;

};

export default function Text({
  value,
  setValue,
  url,
  field,
  delay = 1000,
  fontSize = "",
  vnd = false,
  align,
  style = {},
  http = "post",
  label,
  fullWidth,
  helperText,
  type,
  error,
  startAdornment,
  endAdornment,
  autoComplete,

}: TextType) {


  const [first, setFirst] = useState(false);

  useEffect(() => {
    if (url && field) {
      const db = debounce(url, field, value, first, delay);
      setFirst(true);
      return () => {
        if (typeof db === "function") db();
      };
    }
  }, [value])
  
    let labelClass = "text-xs pl-1 ";
    let helperClass = "h-3 text-xs pt-1 pl-1 mb-2 ";

    if (error) {
      labelClass += "text-red-500 ";
      helperClass += "text-red-500 ";
    } else {
      labelClass += "text-cyan-700 ";
      helperClass += "text-gray-500 ";
    }

    let fs = "";
    if (fontSize === "small") fs = "text-xs";
  if (fontSize === "medium") fs = "text-sm";

  

  let textAlign = vnd ? "text-right" : "text-left"
  if(align) textAlign = `text-`+align
  

  
  return (
    <div>
      <div className={labelClass}>{label}</div>
      <div
        className={
          "flex items-center border p-1 rounded-lg " +
          (error ? "border-red-500" : "border-gray-300")
        }
      >
        {startAdornment && (
          <div className="px-2 text-gray-600 mr-1">{startAdornment}</div>
        )}
        {vnd ? (
          <NumberFormat
            value={value}
            onValueChange={(values) => {
              setValue(values.value); // raw number
            }}
            thousandSeparator=","
            suffix=" ₫"
            className={`flex-1 border-none outline-none p-1 pl-2 ${textAlign} ${fs}`}
            allowNegative={false}
          />
        ) : (
          <input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={`flex-1 border-none outline-none p-1 pl-2 ${fs} ${textAlign}`}
            type={type || "text"}
            autoComplete={autoComplete || "off"}
          />
        )}
        {endAdornment && (
          <div className="px-2 text-gray-600 ml-1">{endAdornment}</div>
        )}
      </div>

      <div className={helperClass}>{helperText || ""}</div>
    </div>
  );
};
